import React from 'react'

const RightsSelect = props => {
  const { bRole, handleRightsChange, userEdit, userData } = props

  let rights = [
    {id: 1, label: 'master admin'},
    {id: 2, label: 'local admin'},
    {id: 3, label: 'view only'}
  ]

  // if user is a local admin, he should not have access to master admin
  if (userData.bRole === 2) rights.shift()

  return (
    <div style={{ width: userEdit ? '35%' : '50%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: "flex-start", marginLeft: userEdit ? '2vmin' : '4vmin' }}>
        <p style={{ margin: 0, marginBottom: '1.5vmin', fontSize: '1.5vmin', fontWeight: 'bold', textDecoration: "underline" }}>User Rights</p>

        {rights.map(r => (
          <div key={r.label} style={{ display: "flex", alignItems: 'center', marginBottom: '.25vmin' }}>
            <input
              type="radio"
              name="radio"
              id={r.id}
              value={r.id}
              checked={bRole && bRole === r.id ? true : false}
              style={{ cursor: 'pointer', height: '1.2vmin', width: '1.2vmin' }}
              onChange={() => handleRightsChange(r.id)}/>
            <span style={{ marginLeft: '1vmin', fontSize: '1.4vmin' }}>{r.label}</span>
          </div>
        ))}

      </div>
    </div>
  )
}

export default RightsSelect